import * as PIXI from 'pixi.js';

import AssetsLoader from '../utils/assetsLoader';

import ButtonContainer from './buttonContainer';

export default class FtuePopupContainer extends PIXI.Container {
    constructor() {
        super();

        const ftuePopupInfo = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.FTUE_POPUP_INFO));
        ftuePopupInfo.label = 'ftuePopupInfo';
        ftuePopupInfo.x = 0;
        ftuePopupInfo.y = -100;
        ftuePopupInfo.anchor.set(0.5);
        this.addChild(ftuePopupInfo);

        const ftueInfoText = new PIXI.Text({
            text: 'Tap and Hold a card\nto read about it!',
            style: {
                fontFamily: 'Open Sans',
                fontSize: 70,
                fontWeight: '600',
                fill: '#ffffff',
                align: 'center',
            },
        });
        ftueInfoText.label = 'ftueInfoText';
        ftueInfoText.x = 0;
        ftueInfoText.y = 390;
        ftueInfoText.anchor.set(0.5);
        this.addChild(ftueInfoText);

        const closeButton = new ButtonContainer({
            bgAssetName: AssetsLoader.eDefaultAssetsAliases.CLOSE_CARD_INFO_X,
            eventName: 'closeFtuePopupClicked',
        });
        closeButton.label = 'closeButton';
        closeButton.x = 0;
        closeButton.y = 610;
        this.addChild(closeButton);
    }
}